// @ts-ignore
import * as React from 'react';

export type Props = {
	moduleId: string
	type?: string
	thumbnail?: string
	color?: string
	sides?: number
	saturation?: number
	hue?: number
	brightness?: number
	contrast?: number
}

export default class ModuleIcon extends React.Component<Props> {
	public visible():boolean {
		return this.props.thumbnail != "" || this.props.color != "";
	}

	private getPolygonClipPath():string {
		let clipPath = "polygon(";

		let size = 50; //percent
		let angle = (Math.PI*2)/this.props.sides;

		for (var i = 0; i < this.props.sides; ++i) {
			if(i > 0) clipPath += ",";

			let x = Math.round(50*(1 + Math.cos(i * angle)));
			let y = Math.round(50*(1 + Math.sin(i * angle)));

			clipPath += x+"% "+y+"%";
		}

		clipPath += ")";
		return clipPath;
	}

	render() {
		let style = {
			backgroundImage: this.props.thumbnail ? "url('"+this.props.thumbnail+"')" : undefined,
			backgroundColor: this.props.color ? this.props.color : undefined,
			clipPath: this.props.sides ? this.getPolygonClipPath() : undefined,
		};
		let subStyle = {};

		if(this.props.saturation !== undefined) {
			style.backgroundColor = 'hsl(237, 50%, 50%)';
			subStyle.backgroundColor = 'hsl(237, '+(50 + (this.props.saturation - 1)*50)+'%, 50%)';
		}

		if(this.props.hue !== undefined) {
			style.backgroundColor = 'hsl(237, 50%, 50%)';
			subStyle.backgroundColor = 'hsl('+((237 + this.props.hue*360) % 360)+', 50%, 50%)';
		}

		if(this.props.brightness !== undefined && this.props.contrast !== undefined) {
			let r = Math.min(255, Math.max(0, 64 * this.props.contrast + this.props.brightness*255));
			let g = Math.min(255, Math.max(0, 70 * this.props.contrast + this.props.brightness*255));
			let b = Math.min(255, Math.max(0, 191 * this.props.contrast + this.props.brightness*255));

			style.backgroundColor = 'hsl(237, 50%, 50%)';
			subStyle.backgroundColor = 'rgb('+r+', '+g+', '+b+')';
		}

		return style.backgroundImage || style.backgroundColor ? <div className={'module-icon '+this.props.type} style={style}><div style={subStyle}></div></div> : null
	}
}